import * as React from 'react';

/**
 * @see https://github.com/VKCOM/VKUI/pull/9603
 */
export const LockFloatingPositionContext = React.createContext(false);
